


















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ItemDetailFailure extends Vue {
  @Prop() error!: string;
}
